import React from 'react'
import styles from './PageShell.module.scss'

interface PageShellProps {
  children: React.ReactNode
  className?: never
}

export const PageShell: React.FC<PageShellProps> = ({ children }) => (
  <div className={styles.shell}>{children}</div>
)
